import { LoadService } from 'src/app/services/application/load.service';
import { IMenu } from '../../../interfaces/menu.interfaces';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-index',
    templateUrl: './index.component.html',
    styleUrls: ['./index.component.scss'],
    standalone: false
})
export class IndexComponent implements OnInit {
    // private _setting: any;
    private roleSystem: boolean | undefined;
    private settingMenu: String[];
    public panelsMenu: IMenu[] = []; // Список блоков меню

    /* Создание компонента и загрузка меню */
    public constructor(
        private load: LoadService,
        private title: Title,
    ) {
        this.roleSystem =
            load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.LOGIN.IS_ROLES_SYSTEM;

        const tmpTitle =
            load.configData?.CLIENT_SETTINGS.PAGES_SETTINGS.HOME.TITLE;
        if (tmpTitle) this.title.setTitle(tmpTitle);

        if (
            load.configData?.CLIENT_SETTINGS &&
            load.configData.CLIENT_SETTINGS.ENABLED_MODULES.length > 5
        ) {
            this.settingMenu =
                load.configData.CLIENT_SETTINGS.ENABLED_MODULES.split(',');
        } else {
            this.settingMenu = [];
        }
    }

    public ngOnInit(): void {
        this.getMenu();
    }

    /* Получение меню */
    public getMenu(): void {
        /* Параметры
    1) Запись к врачу  - to-doctor
    2) Лаборатория     -  laboratory
    3) Финансы             - payments
    4) Мои посещения  -  h-doctor && history
    5) Услуги                - services

     */
        this.panelsMenu = [];
        const authAccessConfig = this.load.getAccessUserConfig;
        if (this.roleSystem) {
            authAccessConfig.forEach((menu) => {
                switch (menu) {
                    case 'lk_access_appointment':
                        this.panelsMenu.push({
                            name: 'Запись к врачу',
                            img: './assets/images/home/doctor-appointment.png',
                            url: '/home/rec',
                            order: 1,
                        });
                        break;
                    case 'lk_access_appointment_service':
                        this.panelsMenu.push({
                            name: 'Запись на услугу',
                            img: './assets/icons/home/service-appointment-panel.svg',
                            url: '/home/record-services',
                            order: 2,
                        });
                        break;
                    case 'lk_access_lab':
                        this.panelsMenu.push({
                            name: 'Лаборатория',
                            img: './assets/images/home/laboratory.png',
                            url: '/home/labs',
                            order: 4,
                        });
                        break;
                    case 'lk_access_payment':
                        this.panelsMenu.push({
                            name: 'Финансы',
                            img: './assets/images/home/finances.png',
                            url: '/home/payments',
                            order: 5,
                        });
                        break;
                    case 'lk_access_future_visit':
                    case 'lk_access_history':
                        this.panelsMenu.push({
                            name: 'Мои посещения',
                            img: './assets/images/home/visit-history.png',
                            url: '/home/history',
                            order: 3,
                        });
                        break;
                    case 'lk_access_see_services':
                        this.panelsMenu.push({
                            name: 'Услуги',
                            img: './assets/images/home/services.png',
                            url: '/home/services',
                            order: 7,
                        });
                        break;
                    case 'lk_access_documents':
                        this.panelsMenu.push({
                            name: 'Документы',
                            img: './assets/icons/home/documents-panel.svg',
                            url: '/home/patient-files',
                            order: 6,
                        });
                        break;
                }
            });
        } else {
            this.settingMenu.forEach((menu) => {
                switch (menu) {
                    case 'to-doctor':
                        this.panelsMenu.push({
                            name: 'Запись к врачу',
                            img: './assets/images/home/doctor-appointment.png',
                            url: '/home/rec',
                            order: 1,
                        });
                        break;
                    case 'record-services':
                        this.panelsMenu.push({
                            name: 'Запись на услугу',
                            img: './assets/icons/home/service-appointment-panel.svg',
                            url: '/home/record-services',
                            order: 2,
                        });
                        break;
                    case 'laboratory':
                        this.panelsMenu.push({
                            name: 'Лаборатория',
                            img: './assets/images/home/laboratory.png',
                            url: '/home/labs',
                            order: 4,
                        });
                        break;
                    case 'payments':
                        this.panelsMenu.push({
                            name: 'Финансы',
                            img: './assets/images/home/finances.png',
                            url: '/home/payments',
                            order: 5,
                        });
                        break;
                    case 'h-doctor':
                    case 'history':
                        this.panelsMenu.push({
                            name: 'Мои посещения',
                            img: './assets/images/home/visit-history.png',
                            url: '/home/history',
                            order: 3,
                        });
                        break;
                    case 'services':
                        this.panelsMenu.push({
                            name: 'Услуги',
                            img: './assets/images/home/services.png',
                            url: '/home/services',
                            order: 7,
                        });
                        break;
                    case 'documents':
                        this.panelsMenu.push({
                            name: 'Документы',
                            img: './assets/icons/home/documents-panel.svg',
                            url: '/home/patient-files',
                            order: 6,
                        });
                        break;
                }
            });
        }
        this.panelsMenu = this.panelsMenu
            .filter(
                (item, index, self) =>
                    self.findIndex((t) => t.name === item.name) === index,
            )
            .sort((a, b) => a.order - b.order);

        //legacy govna(полного)
    }
}
